import { useCallback, useEffect, useState } from 'react';

import { MessageModal } from '~extension/web2print/view/MessageModal/MessageModal';
import useDelayFn from '~hooks/useDelayFn';

export function MessageModalController({ message, onClose }: { message: string; onClose: () => void }) {
  const delayedOnClose = useDelayFn(onClose, 500);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    setIsOpen(Boolean(message));
  }, [message]);

  // Handler: close dialog, but delay the closing to have smoother transitions
  const handleOnClose = useCallback(() => {
    setIsOpen(false);
    delayedOnClose();
  }, [delayedOnClose]);

  return <MessageModal isOpen={isOpen} onClose={handleOnClose} message={message} />;
}
